import { useUnit } from 'effector-react';
import { $global, storage } from 'models/store-global';
import { useLocation } from 'react-router-dom';

import { Tab, TabsWrapper } from 'components/pages/Dashboard/DashboardHeader';

import { MyStore } from 'types/Store';

const OrigSpouseTabs = () => {
    const community = useUnit($global.map((state) => state.community));
    const participantId = useUnit($global.map((state) => state.temp?.selected_community_participant || -1));
    const { tabs: communityTabs = [], realm: participants = [] } = community || {};
    const path = useLocation().pathname.split('/').slice(1);

    const selectedTab = communityTabs.indexOf(participantId);
    const tabs = participants
        .filter((i) => communityTabs.includes(i.participant_id))
        .map(
            (i) =>
                ({
                    title: `${i.first_name} ${i.last_name}`,
                    onClick: () => {
                        storage.set(
                            (store): MyStore => ({
                                ...store,
                                temp: { ...(store.temp || {}), selected_community_participant: i.participant_id },
                            }),
                        );
                    },
                } as const),
        );

    return (
        <TabsWrapper>
            {tabs.length > 1 &&
                path?.[1] !== 'assigned' &&
                tabs.map((tab, index) => {
                    return (
                        <Tab
                            id={`tab-${index}`}
                            key={index}
                            selected={selectedTab === index}
                            onClick={() => {
                                tab?.onClick?.();
                            }}
                            tabsNumber={tabs.length || 1}
                        >
                            {tab.title}
                        </Tab>
                    );
                })}
        </TabsWrapper>
    );
};

export default OrigSpouseTabs;
